var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreentickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_7549)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.19727,
    y: 1.4209,
    width: 16.0919,
    height: 16.0919,
    rx: 1.78799,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6615 9.52021C15.6615 12.4826 13.26 14.8842 10.2976 14.8842C7.33512 14.8842 4.93359 12.4826 4.93359 9.52021C4.93359 6.55778 7.33512 4.15625 10.2976 4.15625C13.26 4.15625 15.6615 6.55778 15.6615 9.52021Z",
    fill: "#36BA3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5948 7.94717C12.6827 8.03382 12.6837 8.17528 12.597 8.26312L9.6646 11.2359C9.62262 11.2785 9.56533 11.3024 9.50555 11.3024C9.44576 11.3024 9.38847 11.2785 9.34649 11.2359L8.01358 9.88465C7.92693 9.7968 7.9279 9.65535 8.01574 9.5687C8.10358 9.48205 8.24504 9.48301 8.33169 9.57086L9.50555 10.7609L12.2789 7.94933C12.3655 7.86149 12.507 7.86052 12.5948 7.94717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6928 7.84757C12.8353 7.98814 12.8369 8.21761 12.6963 8.36011L9.76391 11.3329C9.6958 11.402 9.60287 11.4408 9.50589 11.4408C9.40891 11.4408 9.31597 11.402 9.24786 11.3329L7.91495 9.98164C7.77439 9.83913 7.77596 9.60966 7.91846 9.4691C8.06096 9.32853 8.29043 9.3301 8.431 9.4726L9.50589 10.5623L12.1803 7.85108C12.3208 7.70857 12.5503 7.707 12.6928 7.84757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_7549",
    x: 0.856276,
    y: 0.526906,
    width: 18.7738,
    height: 18.7738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.446996
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.670495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_7549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_7549",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentickIcon);
export default __webpack_public_path__ + "static/media/greentickIcon.8a105b56596483dd34a3c5f89de311d9.svg";
export { ForwardRef as ReactComponent };